module.exports = __webpack_public_path__ + "img/winerackdog37.d59d76cd.jpg";